import type {
  OrganizationListModel,
  OrganizationListRSModel,
} from '@/features/mold/models/organization-list';
import { t } from '@/i18n';
import { createCsv } from '@/utils';
import type { z } from 'zod';

type Data = z.infer<typeof OrganizationListModel>;
type RSData = z.infer<typeof OrganizationListRSModel>;

const ORGANIZATION_LIST_CSV_RS_HEADER_ORDER: (keyof RSData[number])[] = [
  'flattenExternalSystemCode',
  'code',
  'name',
  'startYear',
  'endYear',
];

const ORGANIZATION_LIST_CSV_HEADER_ORDER: (keyof Data[number])[] = [
  'flattenExternalSystemCode',
  'externalSystemCode',
  'code',
  'name',
  'startYear',
  'endYear',
];

const ORGANIZATION_LIST_CSV_RS_HEADER: {
  [k in (typeof ORGANIZATION_LIST_CSV_RS_HEADER_ORDER)[number]]: string;
} = {
  flattenExternalSystemCode: t(
    'organization-list-csv-header-flatten-external-system-code',
  ),
  code: t('organization-list-csv-header-code'),
  name: t('organization-list-csv-header-name'),
  startYear: t('organization-list-csv-header-start-year'),
  endYear: t('organization-list-csv-header-end-year'),
};

const ORGANIZATION_LIST_CSV_HEADER: {
  [k in (typeof ORGANIZATION_LIST_CSV_HEADER_ORDER)[number]]: string;
} = {
  flattenExternalSystemCode: t(
    'organization-list-csv-header-flatten-external-system-code',
  ),
  code: t('organization-list-csv-header-external-system-code'),
  externalSystemCode: t('organization-list-csv-header-code'),
  name: t('organization-list-csv-header-name'),
  startYear: t('organization-list-csv-header-start-year'),
  endYear: t('organization-list-csv-header-end-year'),
};

export const getOrganizationListCsvRSData = ({ data }: { data: RSData }) =>
  createCsv({
    headerKeys: ORGANIZATION_LIST_CSV_RS_HEADER_ORDER,
    headerConverter: ORGANIZATION_LIST_CSV_RS_HEADER,
    body: data,
  });

const _getOrganizationListCsvData = ({ data }: { data: Data }) =>
  createCsv({
    headerKeys: ORGANIZATION_LIST_CSV_HEADER_ORDER,
    headerConverter: ORGANIZATION_LIST_CSV_HEADER,
    body: data,
  });
